import React from 'react';

import { UserAvatarContainer as UserAvatar } from '../../containers';

import styles from './Header.module.scss';

const HeaderRightContent = () => (
  <div className={styles.rightContentWrapper}>
    <UserAvatar />
  </div>
);

export default HeaderRightContent;
